// src/features/inventory/hooks/useStockTransactions.js
import { useState, useCallback } from 'react';
import { stockAPI } from '../services/stock';
import { useApi } from '../../../hooks/api/useApi';

export function useStockTransactions() {
  const [transactions, setTransactions] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchTransactions = useCallback(async (itemId) => {
    const result = await execute(() => stockAPI.getTransactions(itemId));
    if (result.success) {
      setTransactions(result.data.data || []);
    }
    return result;
  }, [execute]);

  const fetchTransactionsByLot = useCallback(async (lotId) => {
    const result = await execute(() => stockAPI.getTransactions(null, { lotId }));
    if (result.success) {
      setTransactions(result.data.data || []);
    }
    return result;
  }, [execute]);

  return { transactions, loading, error, clearError, fetchTransactions, fetchTransactionsByLot };
}
